import { BodyStatsService } from "@/clients/services/BodyStatsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetBodyStats = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.BODY_STATS],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await BodyStatsService.getBodyStatsApiV1BodyStatsGet(
        user.id,
      );

      return data;
    },
  });

  return { bodyStats: data, isLoading, error };
};
